export const CHECK_TOKEN_ITERVAL = 5000
